import { Button } from '@microservices/wiskey-react-components'
import { Delete, Edit } from '@mui/icons-material'
import { Grid, Typography } from '@mui/material'

import { getEmptyEvent } from '../helpers'

import { EventEdit } from './EventEdit'
import { useEvent } from './hooks/useEvent'

type EventProps = {
  sectionIndex: number
  tabIndex: number
  actionIndex: number
  eventIndex: number
  removeEvent: (index: number) => void
}

export const Event = ({
  sectionIndex,
  tabIndex,
  actionIndex,
  eventIndex = 0,
  removeEvent,
}: EventProps) => {
  const { handlers, data } = useEvent({
    sectionIndex,
    tabIndex,
    actionIndex,
    eventIndex,
  })

  const { watchValueType, watchEvent, watchValue, watchPostVariable, watchCurrentEvent, isEditEvent } =
    data

  const { handleSaveEvent, handleEditEvent, handleResetEvent } = handlers

  const handleCloseButton = () => {
    handleEditEvent(false)
    handleResetEvent()
  }

  const handleSaveFromEdit = (values: Parameters<typeof handleSaveEvent>[0]) => {
    handleSaveEvent(values)
    handleEditEvent(false)
  }

  if (isEditEvent) {
    return (
      <EventEdit
        initialValues={watchCurrentEvent ?? getEmptyEvent()}
        sectionIndex={sectionIndex}
        tabIndex={tabIndex}
        onCancel={handleCloseButton}
        onSave={handleSaveFromEdit}
      />
    )
  }

  return (
    <Grid
      container
      alignItems={'center'}
      display='flex'
      justifyContent='space-between'
      mt={'5px'}
      xs={12}
    >
      <Grid item xs={2.5}>
        <Typography>{watchEvent?.label}</Typography>
      </Grid>
      <Grid item xs={2.5}>
        <Typography>{watchPostVariable?.label}</Typography>
      </Grid>
      <Grid item xs={2.5}>
        <Typography>{watchValueType?.label}</Typography>
      </Grid>
      <Grid item xs={2.5}>
        <Typography sx={{ maxWidth: '100%', overflow: 'hidden', textOverflow: 'ellipsis' }}>
          {watchValue}
        </Typography>
      </Grid>
      <Grid item>
        <Grid>
          <Button
            onClick={() => {
              handleEditEvent(true)
            }}
          >
            <Edit color={'action'} fontSize='medium' />
          </Button>
          <Button
            onClick={() => {
              removeEvent(eventIndex)
            }}
          >
            <Delete color={'action'} fontSize='medium' />
          </Button>
        </Grid>
      </Grid>
    </Grid>
  )
}
